import { SeoData } from './seo.service';

/**
 * Métadonnées SEO des pages publiques, indexées par chemin.
 *
 * Centralisées ici plutôt que dispersées dans `data: { seo }` sur chacune des
 * ~90 routes : le contenu éditorial se relit et se corrige dans un seul fichier.
 * Une route peut malgré tout surcharger son entrée via `data: { seo }`, qui reste
 * prioritaire (voir `SeoService.apply`).
 *
 * Titres : le suffixe « | Brokins » est ajouté par le service, viser ≤ 50 ici.
 * Descriptions : ≤ 155 caractères, proposition de valeur puis ancrage de l'entité.
 *
 * Base initiale dérivée des `title`/`subtitle` déjà portés par chaque composant de
 * page. À affiner ensuite page par page en visant le mot-clé cible de chacune.
 */
export const PAGE_SEO: Record<string, SeoData> = {
  '/assurance-activite-professionnels': {
    title: 'Assurance d’activité professionnelle',
    description: 'Protégez l’activité de votre entreprise : RC, perte d’exploitation, cyber. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-animaux': {
    title: 'Assurance Chiens - Chats - Animaux',
    description: 'Assurance Chiens - Chats - Animaux : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-auto-particuliers': {
    title: 'Assurance Auto Personnelle',
    description: 'Assurance Auto Personnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-auto-professionnelle': {
    title: 'Assurance Auto Professionnelle',
    description: 'Assurance Auto Professionnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-auto-temporaire': {
    title: 'Assurance Auto Temporaire',
    description: 'Assurance Auto Temporaire : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-biens-particuliers': {
    title: 'Assurance des Biens pour Particuliers',
    description: 'Assurance des Biens pour Particuliers : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-biens-professionnels': {
    title: 'Assurance des biens professionnels',
    description: 'Locaux, matériel, stocks, flotte : couvrez les biens de votre entreprise. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-bris-machine': {
    title: 'Assurance Bris de Machine',
    description: 'Assurance Bris de Machine : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-collective-entreprise': {
    title: 'Assurance Mutuelle Santé Entreprise',
    description: 'Assurance Mutuelle Santé Entreprise : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-credit-emprunteur': {
    title: 'Assurance Crédit Emprunteur',
    description: 'Assurez votre emprunt immobilier. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-credit-professionnel': {
    title: 'Assurance Crédit Professionnel',
    description: 'Assurance Crédit Professionnel : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-cyber-risque': {
    title: 'Assurance cyber-risque',
    description: 'Protégez votre entreprise contre les cyberattaques et leurs conséquences. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-decennale-construction': {
    title: 'Assurance Décennale Construction',
    description: 'Responsabilité décennale obligatoire pour les professionnels du bâtiment. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-dommages-ouvrage': {
    title: 'Assurance Dommages Ouvrage',
    description: 'Assurance Dommages Ouvrage : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-dommages-ouvrage-maitre': {
    title: 'Assurance Dommages-Ouvrage Maître d’Ouvrage',
    description: 'Protection pour les maîtres d’ouvrage professionnels. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-flotte-automobile': {
    title: 'Assurance Flotte Auto Professionnelle',
    description: 'Assurance Flotte Auto Professionnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-flotte-moto-professionnelle': {
    title: 'Assurance Flotte Moto Professionnelle',
    description: 'Assurance Flotte Moto Professionnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-homme-cle': {
    title: 'Assurance Homme-Clé',
    description: 'Assurance Homme-Clé : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-locaux-professionnels': {
    title: 'Assurance Loueur de Véhicules',
    description: 'Protégez votre activité de location avec l’assurance adaptée aux loueurs de véhicules et auto-écoles. Devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-loyers-impayes': {
    title: 'Assurance Loyers Impayés',
    description: 'Assurance Loyers Impayés : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-marchandises-transportees': {
    title: 'Assurance Marchandises Transportées',
    description: 'Protégez vos marchandises pendant leur transport. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-moto-personnelle': {
    title: 'Assurance Moto Personnelle',
    description: 'Assurance Moto Personnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-moto-professionnelle': {
    title: 'Assurance Moto Professionnelle',
    description: 'Assurance Moto Professionnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-multirisque-habitation': {
    title: 'Assurance Multirisque Habitation',
    description: 'Assurance Multirisque Habitation : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-multirisque-immeuble-pno': {
    title: 'Assurance Multirisque Immeuble - MRI - PNO',
    description: 'Assurance Multirisque Immeuble - MRI - PNO : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-multirisque-immeuble-pro': {
    title: 'Assurance Multirisque Immeuble - MRI - PNE',
    description: 'Assurance Multirisque Immeuble - MRI - PNE : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-multirisque-pro': {
    title: 'Assurance Multirisque Professionnelle',
    description: 'Assurance Multirisque Professionnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-mutuelle-sante-internationale': {
    title: 'Assurance Mutuelle Santé Internationale',
    description: 'Assurance Mutuelle Santé Internationale : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-mutuelle-sante-internationale-pro': {
    title: 'Mutuelle santé internationale pro',
    description: 'Couverture santé à l’étranger pour les expatriés et salariés en mission. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-oeuvres-art-bijoux': {
    title: 'Assurance Œuvres d’Art - Bijoux',
    description: 'Assurance Œuvres d’Art - Bijoux : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-personnes-professionnels': {
    title: 'Assurance des personnes en entreprise',
    description: 'Santé, prévoyance et retraite pour les dirigeants et les salariés. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-perte-exploitation': {
    title: 'Assurance Perte d’Exploitation',
    description: 'Assurance Perte d’Exploitation : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-prevoyance-deces': {
    title: 'Assurance Prévoyance Décès',
    description: 'Protégez financièrement vos proches en cas de disparition. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-prevoyance-entreprise': {
    title: 'Assurance Prévoyance Entreprise',
    description: 'Assurance Prévoyance Entreprise : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-prevoyance-gav': {
    title: 'Assurance Prévoyance GAV',
    description: 'Garantie des Accidents de la Vie : Protégez-vous contre les aléas du quotidien. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-prevoyance-ijh': {
    title: 'Assurance Prévoyance IJH',
    description: 'Indemnités Journalières en cas d’Hospitalisation : Préservez vos revenus. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-prevoyance-obseque': {
    title: 'Assurance Prévoyance Obsèques',
    description: 'Assurance Prévoyance Obsèques : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-prevoyance-particuliers': {
    title: 'Assurance Prévoyance Particuliers',
    description: 'Protégez vos proches en cas d’accident, maladie ou décès. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-prevoyance-professionnelle': {
    title: 'Assurance Prévoyance Professionnelle',
    description: 'Assurance Prévoyance Professionnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-protection-juridique': {
    title: 'Assurance Protection Juridique',
    description: 'Assurance Protection Juridique : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-protection-juridique-pro': {
    title: 'Protection juridique professionnelle',
    description: 'Défense de vos intérêts en cas de litige lié à votre activité professionnelle. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-rc-decennale': {
    title: 'Assurance Responsabilité Civile Décennale',
    description: 'Assurance Responsabilité Civile Décennale : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-rc-entreprise': {
    title: 'Assurance Responsabilité Civile',
    description: 'Assurance Responsabilité Civile : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-rc-mandataires-sociaux': {
    title: 'RC des mandataires sociaux',
    description: 'Protégez le patrimoine personnel des dirigeants en cas de faute de gestion. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-rc-pro-generale': {
    title: 'Assurance RC Pro Générale',
    description: 'La responsabilité civile professionnelle, protection essentielle pour toute activité. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-rc-pro-juridique': {
    title: 'Assurance RC Pro Juridique',
    description: 'Protection pour les professionnels du droit et du conseil. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-rc-pro-medicale': {
    title: 'Assurance RC Pro Médicale',
    description: 'Protection spécifique pour les professionnels de santé. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-rc-professionnelle': {
    title: 'Assurance RC Professionnelle',
    description: 'Protégez votre activité contre les risques de responsabilité civile. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-retraite-complementaire-entreprise': {
    title: 'Assurance Retraite Complémentaire Entreprise',
    description: 'Assurance Retraite Complémentaire Entreprise : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-retraite-complementaire-pro': {
    title: 'Assurance Retraite Complémentaire Professionnelle',
    description: 'Assurance Retraite Complémentaire Professionnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-retraite-complementaire-salarie': {
    title: 'Assurance Retraite Complémentaire Salarié',
    description: 'Assurance Retraite Complémentaire Salarié : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-sante-particuliers': {
    title: 'Assurance Mutuelle Santé Individuelle',
    description: 'Protection santé complète pour vous et votre famille. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-sante-professionnels': {
    title: 'Assurance Mutuelle Santé Professionnelle',
    description: 'Assurance Mutuelle Santé Professionnelle : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-tous-risques-chantier': {
    title: 'Assurance Tous Risques Chantier (TRC)',
    description: 'Couvrez tous les risques pendant vos travaux. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-transport': {
    title: 'Assurance Transport',
    description: 'Protection complète pour vos activités de transport. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/assurance-velo-trottinette': {
    title: 'Assurance Vélo - Trottinette Électrique',
    description: 'Assurance Vélo - Trottinette Électrique : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-voyage-personnel': {
    title: 'Assurance Voyage Personnel',
    description: 'Assurance Voyage Personnel : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/assurance-voyage-professionnel': {
    title: 'Assurance Voyage Professionnel',
    description: 'Assurance Voyage Professionnel : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/autres-assurances': {
    title: 'Autres Assurances',
    description: 'Découvrez toute notre gamme de solutions d’assurance. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/avantages-courtier-brokins': {
    title: 'Avantages de passer par un courtier',
    description: 'Avantages de passer par un courtier : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/cgv': {
    title: 'Conditions Générales de Vente',
    description: 'Conditions applicables aux services de courtage en assurance proposés par Brokins. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/contact': {
    title: 'Contact',
    description: 'Email, téléphone, tchat, devis en ligne ou rendez-vous : nos conseillers vous répondent rapidement. Brokins, courtier en assurance.'
  },
  '/devis': {
    title: 'Demander un devis d’assurance',
    description: 'Un courtier cherche et compare les offres pour vous, sans frais de courtage. Devis gratuit avec Brokins, courtier en assurance.'
  },
  '/devis-animaux': {
    title: 'Devis Assurance Animaux',
    description: 'Protégez votre compagnon avec la meilleure couverture santé. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/devis-emprunteur': {
    title: 'Devis Assurance Emprunteur',
    description: 'Comparez les meilleures offres d’assurance crédit immobilier. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/devis-pno': {
    title: 'Devis Assurance PNO',
    description: 'Propriétaire Non Occupant - Protégez votre investissement locatif. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/devis-prevoyance-deces': {
    title: 'Devis Prévoyance Décès',
    description: 'Protégez vos proches avec une couverture adaptée. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/devis-prevoyance-gav': {
    title: 'Devis Garantie Accidents de la Vie',
    description: 'Protégez-vous contre les accidents du quotidien. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/devis-prevoyance-ijh': {
    title: 'Devis Indemnités Journalières Hospitalisation',
    description: 'Complétez vos revenus en cas d’hospitalisation. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/devis-prevoyance-obseques': {
    title: 'Devis Assurance Obsèques',
    description: 'Anticipez et soulagez vos proches des démarches. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/devis-sante-particulier': {
    title: 'Devis Mutuelle Santé Particulier',
    description: 'Comparez les meilleures mutuelles santé. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/devis-sante-professionnelle': {
    title: 'Devis Mutuelle Santé Professionnelle',
    description: 'Solutions santé adaptées aux professionnels et TNS. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/mentions-legales': {
    title: 'Mentions Légales',
    description: 'Informations légales et réglementaires sur Brokins et ses activités de courtage en assurance. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/notre-approche': {
    title: 'Notre Approche',
    description: 'Notre Approche : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/notre-equipe': {
    title: 'Notre Équipe',
    description: 'Des professionnels de l’assurance à votre service. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/politique-confidentialite': {
    title: 'Politique de Confidentialité',
    description: 'Protection et traitement de vos données personnelles conformément au RGPD. Comparaison gratuite par Brokins, courtier en assurance.'
  },
  '/qui-sommes-nous': {
    title: 'Notre Histoire',
    description: 'Notre Histoire : comparez les offres et obtenez un devis gratuit avec Brokins, courtier en assurance.'
  },
  '/recrutement': {
    title: 'Recrutement',
    description: 'Découvrez nos offres d’emploi et rejoignez une équipe de courtiers en assurance. Brokins recrute.'
  },
};
